define('collection/CountryCollection',['require','lib/collection/BaseCollection','model/CountryModel'],function (require) {

    var BaseCollection = require('lib/collection/BaseCollection');
    var CountryModel = require('model/CountryModel');

    /**
     * Country list collection
     *
     * @class CountryCollection
     */
    var CountryCollection = BaseCollection.extend({

        url: '/country/',
        model: CountryModel,
        
        comparator: function(c1, c2) {
            return Locale.get(c1.get('name')).localeCompare(Locale.get(c2.get('name')));
        }

    });

    CountryCollection._instance = null;
    CountryCollection.getInstance = function () {
        if (!CountryCollection._instance) {
            CountryCollection._instance = new CountryCollection();
        }
        return CountryCollection._instance;
    };

    return CountryCollection;

});
